<template>
  <div class="scpmSubTitleContainer">
    <div class="scpmSubTitle">
      <slot></slot>
    </div>
    <div class="action">
      <slot name="action"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ScpmSubTitle',
};
</script>
<style lang="scss" scoped>
.scpmSubTitleContainer {
  display: flex;
  justify-content: space-between;

  .scpmSubTitle {
    height: 24px;
    font-family: $lego__font-family;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: var(--dark);
  }

  .action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
}
</style>